import {collect} from "./analytics";

export const collectPageView = async (productId: string) => {
    return collect(productId, {
        tags: ["page", "view"],
    })
}
